function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Navigate Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.901502742,10.2102023 C0.437628235,10.1169951 0.350696825,9.49136816 0.771586453,9.27522224 L17.7515865,0.555222245 C18.1838982,0.333210559 18.6467894,0.796101802 18.4247778,1.22841355 L9.70477776,18.2084135 C9.48878514,18.6290047 8.86369185,18.542574 8.76993006,18.0791537 L7.44380854,11.52476 L0.901502742,10.2102023 Z M2.50049854,9.51150443 L7.96649726,10.6097977 C8.16383397,10.6494489 8.31815446,10.8035629 8.35806994,11.0008463 L9.46709416,16.4822304 L16.8245409,2.15545913 L2.50049854,9.51150443 Z",
  id: "navigate-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "navigate-Icon/Global/Navigate",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "navigate-Swatches/Midnight",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "navigate-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#navigate-path-1"
})));

var SvgNavigate = function SvgNavigate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavigate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navigate.bc67dfff.svg";
export { ForwardRef as ReactComponent };